import React, { useContext } from 'react';
import { LocaleContext } from 'shared';

import { CertificatesHeaderRow, CertificatesHeaderValue } from './CertificateHeader.styles';

const LOCALE_PREFIX = 'CERTIFICATES.TABLE.HEADER.';
export const CertificatesHeader = () => {
  const localeContext = useContext(LocaleContext);

  return (
    <CertificatesHeaderRow className="certificates-group__table-header">
      <CertificatesHeaderValue className="file-name hide-on-mobile">
        {localeContext.formatMessage({ id: `${LOCALE_PREFIX}FILE-NAME` })}
      </CertificatesHeaderValue>
      <CertificatesHeaderValue className="date-time upload-date hide-on-mobile">
        {localeContext.formatMessage({ id: `${LOCALE_PREFIX}UPLOAD-DATE` })}
      </CertificatesHeaderValue>
      <CertificatesHeaderValue className="fingerprint show-on-mobile">
        {localeContext.formatMessage({ id: `${LOCALE_PREFIX}FINGERPRINT` })}
      </CertificatesHeaderValue>
      <CertificatesHeaderValue className="date-time valid-from hide-on-mobile">
        {localeContext.formatMessage({ id: `${LOCALE_PREFIX}VALID-FROM` })}
      </CertificatesHeaderValue>
      <CertificatesHeaderValue className="date-time valid-to show-on-mobile">
        {localeContext.formatMessage({ id: `${LOCALE_PREFIX}VALID-TO` })}
      </CertificatesHeaderValue>
      <CertificatesHeaderValue className="icon show-on-mobile" isLastColumn={true}>
        {localeContext.formatMessage({ id: `${LOCALE_PREFIX}IS-VALID` })}
      </CertificatesHeaderValue>
    </CertificatesHeaderRow>
  );
};
